var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbf19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e1f29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03664f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005642"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5b01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbf18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb800"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0952381.76190476h8.5709305c.3158664 0 .5719266.25479166.5719266.57533384v8.7540942c0 .3177481-.2540747.5753339-.5719266.5753339h-8.5709305z",
    fill: "url(#d)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.76190476 1.3372386c0-.31774811.2622005-.57533384.57678223-.57533384h1.70893206v9.90476194h-1.70893206c-.31854803 0-.57678223-.2547917-.57678223-.5753339z",
    fill: "url(#e)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#f)",
    height: 9.904762,
    mask: "url(#h)",
    rx: 0.380952,
    width: 2.285714,
    x: 3.047619,
    y: 0.761905
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.23809524 2.28571429c-.21039419 0-.38095238-.1705582-.38095238-.38095239v-.38095238h.38095238c.21039418 0 .38095238.1705582.38095238.38095238 0 .21039419-.1705582.38095239-.38095238.38095239zm6.85714286 0c-.2103942 0-.3809524-.1705582-.3809524-.38095239 0-.21039418.1705582-.38095238.3809524-.38095238h.3809524v.38095238c0 .21039419-.1705582.38095239-.3809524.38095239zm0 6.85714285c.2103942 0 .3809524.17055817.3809524.38095238v.38095238h-.3809524c-.2103942 0-.3809524-.17055817-.3809524-.38095238s.1705582-.38095238.3809524-.38095238zm-6.85714286 0c.21039418 0 .38095238.17055817.38095238.38095238s-.1705582.38095238-.38095238.38095238h-.38095238v-.38095238c0-.21039421.17055819-.38095238.38095238-.38095238z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.14285707 7.23809524c0-.21039419-.17264221-.38095238-.38095231-.38095238h.38095231c-.21039414 0-.53986172-.05787442-.74255947-.14062502 0 0-.78124998-.24032744-.78124998-.62127974 0-.38095231.15494788-.46809893.15494788-.46809893.12481882-.16226448.16342698-.44803874.08539063-.65547972 0 0-.3164868-.70524589-.24033851-1.16213564.07614827-.45688975.43487573-.57066205.43487573-.57066205.18061318-.10562043.32702903-.02685978.32702903.18619651v1.53083584c0 .20845393.14690293.45089067.34528457.55008152l.07133562.03566778c.19069539.09534771.46582027.05210659.61399909-.09607224l-.15647665.15647671c.14840693-.14840695.12181158-.342166-.07657006-.44135685l-.41662019-.20831008v-.38095238h.38095238c.21039421 0 .23404945-.07345145.03566781-.1726423l-.41662019-.20831008v-.38095238h.38095238c.21039421 0 .50148808-.12053571.6496669-.26871455l-.15647665.15647671c.14840693-.14840695.44542581-.26871454.64966691-.26871454.2103942 0 .4544038.1469029.5535947.3452846l.0356678.07133556c.0953477.19069542.1196724.50419399.0521066.70689175l-.139881.41964285c-.06657.19971011.0552455.36160714.2649213.36160714h1.1338479c.212882 0 .5059927-.12053571.6541715-.26871454l-.1564767.15647671c.148407-.14840695.1218116-.342166-.07657-.44135685l-.0713356-.03566778c-.1906954-.09534771-.5219959-.1726423-.726237-.1726423-.2103942 0-.3809524-.17671131-.3809524-.38095238 0-.21039419.1205357-.50148809.2687145-.64966693l.1122379-.11223783v.38095238c0 .21039419.1726423.38095238.3809524.38095238h-.3809524.7619048c.2103942 0 .4544038.1469029.5535946.3452846l.0356678.07133556c.0953478.19069542.1876494.51261978.2009105.72187053 0 0 .0524545.36265806-.0282682.76627122-.0807226.40361315-.1722156.44848031-.1722156.44848031-.1152821.17309954-.2087367.47649876-.2087367.69794593v.75476659c0 .21236534-.1767114.38452145-.3809524.38452145-.2103942 0-.307501-.14690293-.2083101-.34528457l.0356678-.07133562c.0953477-.19069539.0991908-.49218747 0-.69056917l-.0356678-.07133556c-.0953478-.19069542-.1726423-.1685733-.1726423.03566778 0 .21039418-.0734514.52785531-.1726423.72623695l-.0356678.07133562c-.0953477.19069539-.3493536.34528457-.5535947.34528457-.2103942 0-.3075009-.14690293-.2083101-.34528457l.0356678-.07133562c.0953478-.19069539.1726423-.52199588.1726424-.72623695 0-.21039419-.1630743-.38095238-.3845214-.38095238h-.7547667c-.2123654 0-.38452157.1767113-.38452157.38095238 0 .21039418-.07345143.52785531-.17264229.72623695l-.03566773.07133562c-.09534773.19069539-.34935368.34528457-.55359474.34528457-.21039414 0-.30750088-.14690293-.20831002-.34528457l.03566773-.07133562c.09534773-.19069539.17264229-.52199588.17264229-.72623695z",
    mask: "url(#h)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLk);
export default __webpack_public_path__ + "static/media/LK.f7e13a05db1e86b9465c05d220ccd989.svg";
export { ForwardRef as ReactComponent };